export default "__VITE_ASSET__9uf6bIGh__"